export const overflowButtonWidth = 30;
